// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"highSchoolStandingCard__gradient-bg5__xu6Xn","standingsCard":"highSchoolStandingCard__standingsCard__YsmV1"};